import { render } from "./Loader.vue?vue&type=template&id=3084e974&scoped=true"
import script from "../js/loader.js?vue&type=script&lang=js&external"
export * from "../js/loader.js?vue&type=script&lang=js&external"

import "./Loader.vue?vue&type=style&index=0&id=3084e974&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3084e974"]])

export default __exports__